// extracted by mini-css-extract-plugin
module.exports = {"AdviceRequest":"NBjMmp1bMiV10YcnW7V6r"};